import {PageBreakItem} from "../MenuDocumentModel";
import {ReactElement} from "react";
import {FormattedMessage} from "react-intl";
import {SubTitle} from "components/UIComponents/SubTitle";
import {EditorItem} from "../editorUtils";
import {EditorGroup} from "./EditorGroup";

export interface PageBreakEditorProps {
    pageBreak: EditorItem<PageBreakItem>
}

export function PageBreakEditor(props: PageBreakEditorProps): ReactElement {
    return (
        <EditorGroup>
            <SubTitle><FormattedMessage id="editor.pageBreak"/></SubTitle>
        </EditorGroup>
    );
}